/******* START: Import React and Dongles *******/
import { useState} from "react";
/******* END: Import React and Dongles *********/

/******* START: Import Local Files *******/
import { NavLink } from "react-router-dom";
import styles from "./Navbar.module.css";
import Account from "./Account";
// import animations from "../../css/animations.module.css";
import ambientLogo from "../../images/ambientLogo.png"
// import ambientLogo1 from "../../images/ambient_logo"
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";

/******* END: Import Local Files *********/

const Menu = () => (
  <>
    <p>
      <NavLink to="/">Home</NavLink>
    </p>

    <p>
      <NavLink to="/swap">Trade</NavLink>
    </p>
    {/* <p>
      <NavLink to="/swapgraph">SwapV2</NavLink>
    </p> */}
    <p>
      <NavLink to="/liquidity">Liquidity</NavLink>
    </p>
    {/* <p>
      <NavLink to="/liquiditygraph">LiquidityV2</NavLink>
    </p> */}
    {/* <p>
      <NavLink to="/analytics">Analytics</NavLink>
    </p> */}
    <p>
      <NavLink to="/analyticsv2">Analytics</NavLink>
    </p>
  </>
);

const Navbar = (props) => {
  const { switchTheme, theme} = props
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className={styles.navbar}>
      <div className={styles.navbar__links}>
        <div className={styles.navbar__logo}>
          <img src={ambientLogo} alt="ambient" />
          <h3 className={styles.gradient__text}>ambient</h3>
        </div>
        <div className={styles.navbar_links_container}>
          <Menu />
        </div>
      <Account switchTheme={switchTheme} theme={ theme}/>
      </div>
    
          
          {/* <div className={styles.navbar__menu}>
          {toggleMenu
          ? <RiCloseLine  size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line  size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
          <div className={styles.navbar_menu_container}>
            <div className={styles.navbar_menu_container_links} >
              <Menu />
            </div>
          <div className={styles.navbar_menu_container_links_sign}>
              <p>Sign in</p>
             
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default Navbar;
